import { Context } from '@nuxt/types';
import Vue from 'vue'

/**
 * 不能提供给leadpage页面的tea公共参数
 * 法务要求，用户相关的信息不能透传
 */
const CommonParamBanList = [
  "user_status",
  "tt4b_user_id",
  "adv_ids",
  "country",
  "city"
];

/** 筛选出可以透传给父页面的Tea公共参数 */
function filterCommonParamsForParent(
  params: Record<string, string> = {}
): Record<string, string> {
  return Object.entries(params).reduce((acc, [key, val]) => {
    if (CommonParamBanList.includes(key)) {
      return acc;
    }
    return { ...acc, [key]: val };
  }, {});
}

/**
 * 拓展tea & slardar 上报的公共上下文属性
 */
export function extendReportContext(params: Record<string, string> = {}, context?: Context) {
  // 使用@slardar/vue-error-handler里面封装的统一的拓展上报上下文函数
  Vue.prototype.$commonReport?.extendContext?.(params)

  // iframe父页面公共参数筛选后配置
  const commonParamsForParent = filterCommonParamsForParent(params);
  // 如果筛选过后没参数，则无需设置
  if (!Object.keys(commonParamsForParent || {}).length) return;
  context?.$handshake?.setTeaCommonParams?.(commonParamsForParent);
}
